module.exports = __webpack_public_path__ + "img/sceneThree.175c679a.png";